import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { OtpInputComponent } from 'src/app/components/shared/otp-input/otp-input.component';
import { editMedProfLoginData } from 'src/app/models/medi-prof-login-edit-data';
import { ApiResult, PromiseResult } from 'src/app/models/PromiseResult';
import { Edit_Data } from 'src/app/models/User';
import { OTP_Validate } from 'src/app/models/util.models';
import { DoctorsService } from 'src/app/services/doctors.service';

@Component({
  selector: 'app-doctor-login-edit-data',
  templateUrl: './edit-data.component.html',
  styleUrls: ['./edit-data.component.css']
})
export class EditDataComponent implements OnInit {

  @Input("editLoginData")
  editLoginData: editMedProfLoginData = new editMedProfLoginData();

  @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;



  editData: Edit_Data = new Edit_Data();

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly doctorService: DoctorsService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.editData.userGuid = sessionStorage.getItem('userid');
    this.editData.emailData.data.setCurrentType(true);
    this.editData.mobileData.data.setCurrentType(false);
    await this.getEmailPhoneNo();
  }

  async getEmailPhoneNo() {
    this.editData.emailData.has_verified = this.editLoginData.has_verified_email;
    this.editData.emailData.value = this.editData.getValue(this.editLoginData.e_email);
    this.editData.emailData.data.userid_value = this.editData.getValue(this.editLoginData.e_email);
    this.editData.mobileData.has_verified = this.editLoginData.has_verified_phone;
    this.editData.mobileData.data.selected_country_data.phone_code = "+" + this.editLoginData.country_phone_code.toString();
    this.editData.mobileData.value = this.editData.addSignAtStart(this.editLoginData.primary_contact_number);
    this.editData.mobileData.data.userid_value = this.editData.getPhoneNumber(this.editData.mobileData.data.selected_country_data.phone_code, this.editData.mobileData.value);
    this.editData.mobileData.data.country_codes = [this.editLoginData.country_codes.filter((ele) => {
      return ele.id == this.editLoginData.country_id;
    })[0].value];
  }

  displayEmailPhone(value: string) {
    return Boolean(value) ? value : "N/A";
  }

  isPosting() {
    return this.editData.mobile_email_fetch_api_result.Posting ||
      this.editData[this.getCurrentEditKey()].edit_api_result.Posting ||
      this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.Posting ||
      this.editData.patientEdit_Data.patient_update_api_result.Posting;
  }

  editEmail() {
    this.editData.emailData.data.userid_value = this.editData.getValue(this.editData.emailData.value);
    this.editData[this.getCurrentEditKey()].reset_data();
    this.editData.emailData.isEdit = true;
  }

  editMobile() {
    this.editData.mobileData.data.userid_value = this.editData.getPhoneNumber(this.editData.mobileData.data.selected_country_data.phone_code, this.editData.mobileData.value);
    this.editData[this.getCurrentEditKey()].reset_data();
    this.editData.mobileData.isEdit = true;
  }

  cancelEditEmail() {
    this.editData[this.getCurrentEditKey()].reset_data();
    this.editData.emailData.data.userid_value = this.editData.getValue(this.editData.emailData.value);
  }

  cancelEditMobile() {
    this.editData[this.getCurrentEditKey()].reset_data();
    this.editData.mobileData.data.userid_value = this.editData.getPhoneNumber(this.editData.mobileData.data.selected_country_data.phone_code, this.editData.mobileData.value);
  }

  async submitEditEmail() {
    this.editData.emailData.data.email = this.editData.emailData.data.userid_value;
    await this.updateCredentials(this.editData.emailData.data.email)
  }

  async submitEditMobile() {
    this.editData.mobileData.data.contact_number = this.editData.mobileData.data.selected_country_data.phone_code + this.editData.mobileData.data.userid_value;
    await this.updateCredentials(this.editData.mobileData.data.contact_number);
  }

  isEmailEdit() {
    return this.editData.emailData.isEdit;
  }

  getCurrentEditKey() {
    return this.isEmailEdit() ? "emailData" : "mobileData";
  }

  async updateCredentials(value: string) {
    this.editData[this.getCurrentEditKey()].edit_api_result = new ApiResult(true);
    await this.doctorService
      .updateCredentialsMedProf(value)
      .toPromise()
      .then((result) => {
        this.editData[this.getCurrentEditKey()].edit_api_result.PromiseResult = result;
        if (result.success) {
          this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.user_guid = result.data.userid;
          this.editData[this.getCurrentEditKey()].tabViewData.nextTab(1);
          this.set_otp_data(result);
        }
        else {
          this.editData[this.getCurrentEditKey()].edit_api_result.ErrorModel = result.error;
        }
        this.editData[this.getCurrentEditKey()].edit_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.editData[this.getCurrentEditKey()].edit_api_result.ServerError = error.error;
        this.editData[this.getCurrentEditKey()].edit_api_result.PromiseResult.success = false;
        this.editData[this.getCurrentEditKey()].edit_api_result.Posting = false;
      });
  }

  set_otp_data(result: PromiseResult) {
    this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.service_id = result.data.service_id;
    this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
  }

  async otp_resend() {
    this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.retry = true;
    await this.update_validate_or_resend_otp();
  }

  async otpVerifySubmit() {
    this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.retry = false;
    await this.update_validate_or_resend_otp();
  }

  async update_validate_or_resend_otp() {
    let data: OTP_Validate = new OTP_Validate();
    this.editData[this.getCurrentEditKey()].otp_data.otp_api_result = new ApiResult(true);
    data = this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api;
    await this.doctorService
      .credentials_validate_or_resend_otp_MedProf(data)
      .toPromise()
      .then(async (result) => {
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.PromiseResult = result;
        if (result.success) {
          if (this.editData[this.getCurrentEditKey()].otp_data.OTP_validate_api.retry) {
            this.set_otp_data(result);
            this.changeDetector.detectChanges();
            await this.OTP_Input.init_countdown();
          }
          else {
            this.verified(result);
          }
        }
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.ServerError = error.error;
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.PromiseResult.success = false;
        this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.Posting = false;
      })
  }

  verified(result: PromiseResult) {
    if (result.success) {
      this.editData[this.getCurrentEditKey()].has_verified = true;
      let value: string = ""
      if (this.isEmailEdit()) {
        value = this.editData.emailData.data.email;
      }
      else {
        value = this.editData.mobileData.data.contact_number;
      }
      this.editData[this.getCurrentEditKey()].value = value;
      this.editData[this.getCurrentEditKey()].otp_data.otp_api_result.ErrorModel.message = "Verified Successfully."
      this.editData[this.getCurrentEditKey()].tabViewData.prevTab(0);
      this.editData[this.getCurrentEditKey()].isEdit = false;
    }
  }

}
